import classFrom from '../../util/inherit';
import ConditionalStrategy from './conditional-creation-strategy';

var __super = ConditionalStrategy.prototype;

/**
 * The `reuse-per-session` strategy creates a new run when the current one is not in the browser cookie.
 *
 * Using this strategy means that when end users navigate between pages in your project, or refresh their browsers, they will still be working with the same run. However, if end users log out and return to the project at a later date, a new run is created.
 *
 * This strategy is useful if your project is structured such that immediately after a run is created, the model is executed completely (for example, a Vensim model that is stepped to the end as soon as it is created). In contrast, if end users play with your project for an extended period of time, executing the model step by step, the `reuse-across-sessions` strategy is probably a better choice (it allows end users to pick up where they left off, rather than starting from scratch each browser session).
 *
 * Specifically, the strategy is:
 *
 * * Check the `sessionKey` cookie.
 *     * This cookie is set by the [Run Manager](../run-manager/) and configurable through its options.
 *     * If the cookie exists, use the run id stored there.
 *     * If the cookie does not exist, create a new run for this end user.
 */
var Strategy = classFrom(ConditionalStrategy, {
    constructor: function (options) {
        __super.constructor.call(this, this.createIf, options);
    },

    createIf: function (run, headers) {
        // If user refreshed and the faciliator deleted the run, create a new run
        if (run.trashed) {
            return true;
        }
        // if we are here, it means that the run exists... so we don't need a new one
        return false;
    }
});

export default Strategy;



// WEBPACK FOOTER //
// ./src/managers/run-strategies/reuse-per-session.js